module.exports = __webpack_public_path__ + "static/media/tela-digitalizacao.4701893a.png";